import api from '@/api'

export default {
  cancelNewRecommendation({ commit }) {
    commit('CANCEL_NEWRECOMMENDATION')
  },
  setRecommendationActivation({ commit }, data) {
    commit('SET_RECOMMENDATIONACTIVATION', data)
  },
  addRecommendation({ commit, state }, data) {
    commit('ADD_RECOMMENDATION', data)
  },
  setRecommendation({ commit, state }, data) {
    commit('SET_RECOMMENDATION', data)
  },
  async getCalibrationRecommendation({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      api.getCalibrationRecommendation(id)
        .then(response => {
          commit('SET_RECOMMENDATION', response.data)
          resolve(response)
        })
    })
  },
  async getCalibrationRecommendations({ commit, state }, make) {
    return new Promise((resolve, reject) => {
      api.getCalibrationRecommendations(make)
        .then(response => {
          commit('SET_RECOMMENDATIONS', response.data)
          resolve(response)
        })
    })
  },
  async saveCalibrationRecommendations({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.saveCalibrationRecommendations(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async deleteCalibrationRecommendation({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      api.deleteCalibrationRecommendation(id)
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrate/actions.js